import { render, staticRenderFns } from "./ItDetails.vue?vue&type=template&id=7cb53f95&scoped=true&"
import script from "./ItDetails.vue?vue&type=script&lang=js&"
export * from "./ItDetails.vue?vue&type=script&lang=js&"
import style0 from "./ItDetails.vue?vue&type=style&index=0&id=7cb53f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb53f95",
  null
  
)

export default component.exports